/* eslint-disable no-alert */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { render } from "react-dom";

import Salert from "react-s-alert";
import {
  getVerificationCodeByName,
  sendVerifyCodeWithName,
  resetPassword,
} from "@shared/scripts/features/api";
import ForgetPwd from "./forget/ForgetPwd";
import ResetPwd from "./forget/ResetPwd";
import VerificationCode from "./forget/VerificationCode";
import RucaptchaModal from "./forget/RucaptchaModal";
import ReduxWrapper from "../utils/ReduxWrapper";

/**
 * 根据当前页面和查询参数构造要跳转的 URL（不执行跳转，只返回字符串）
 *
 * Query params:
 *  - from: 要替换/添加的子域（例如 "a" 或 "b"）
 *  - path: 可选，目标 path（可以是 "foo" 或 "foo/bar"）
 *
 * 规则:
 *  - 无查询参数 或 from/path 都不存在 → 返回当前 origin
 *  - from 存在 → 替换/添加子域
 *  - path 存在 → 追加安全编码后的 path
 *
 * 返回: 完整 URL 字符串
 */
function getRedirectUrlFromQuery({ fromKey = "from", pathKey = "path" } = {}) {
  const params = new URLSearchParams(window.location.search || "");

  // 没有查询参数 → 直接返回当前 origin
  if (!params.toString()) {
    return `${location.protocol}//${location.host}`;
  }

  const fromRaw = params.get(fromKey);
  const pathRaw = params.get(pathKey);

  // from 和 path 都没有时 → 返回当前 origin
  if (!fromRaw && !pathRaw) {
    return `${location.protocol}//${location.host}`;
  }

  /** -------- 1. 构造 host（当 from 存在时才处理） -------- */
  let newHost = location.host; // 默认保持不变

  if (fromRaw) {
    // 清洗 subdomain
    const sub = String(fromRaw)
      .replace(/[^a-zA-Z0-9-]/g, "")
      .toLowerCase();

    if (sub) {
      const host = location.host;
      const [hostname, port] = host.split(":");
      const labels = hostname.split(".");

      // 有 3+ labels → 替换第一个；否则添加
      if (labels.length >= 3) {
        labels[0] = sub;
      } else {
        labels.unshift(sub);
      }

      const newHostname = labels.join(".");
      newHost = port ? `${newHostname}:${port}` : newHostname;
    }
  }

  let target = `${location.protocol}//${newHost}`;

  /** -------- 2. path 存在则追加 -------- */
  if (pathRaw) {
    const safePath = String(pathRaw)
      .split("/")
      .filter(Boolean)
      .map(seg => encodeURIComponent(seg))
      .join("/");

    if (safePath) {
      target += `/${safePath}`;
    }
  }

  return target;
}

class RetrievePwd extends React.Component {
  constructor() {
    super();

    this.state = {
      activeIndex: 0,
      loginName: "",
    };
    console.log("back", getRedirectUrlFromQuery());
  }

  getVerificationCode(loginName, rucaptcha, cb, hasTip = false) {
    getVerificationCodeByName(loginName, rucaptcha)
      .done(res => {
        if (res.success) {
          if (hasTip) {
            Salert.success("验证码已发送！");
          }

          this.switchIndex(1);
          this.props.actions.closeModal();

          if (this.props.isMobile) {
            $(".js-forget-modal").removeClass("is-visible");
            $("body").removeClass("open-modal");
          }
        }
      })
      .fail(xhr => {
        if (this.props.isMobile) {
          alert(xhr.responseText);
        }
        cb();
      });
  }

  setloginNameAndSend(name, rucaptcha, cb) {
    this.setState({
      loginName: name,
    });
    this.getVerificationCode(name, rucaptcha, cb);
  }

  switchIndex(index) {
    this.setState({
      activeIndex: index,
    });
  }

  sendVerify(code) {
    sendVerifyCodeWithName(this.state.loginName, code).done(res => {
      if (res.success) {
        this.switchIndex(2);
      }
    });
  }

  resetPwd(password) {
    resetPassword(this.state.loginName, password).done(res => {
      if (res.success) {
        const href = getRedirectUrlFromQuery();
        window.location.href = href;
      }
    });
  }

  resend() {
    if (this.props.isMobile) {
      $(".js-forget-modal").addClass("is-visible");
      $("body").addClass("open-modal");
      render(
        <RucaptchaModal
          resendTo={(rucaptcha, cb) => {
            this.getVerificationCode(this.state.loginName, rucaptcha, cb, true);
          }}
        />,
        document.getElementById("js-modal-main")
      );
      return;
    }

    this.props.actions.openModal("rucaptcha", {
      resendTo: (rucaptcha, cb) => {
        this.getVerificationCode(this.state.loginName, rucaptcha, cb, true);
      },
    });
  }

  render() {
    const { activeIndex } = this.state;

    return (
      <div className="u-container">
        <div className="u-col-10 forget-step__container">
          <div
            className={`forget-step ${activeIndex === 0 ? "is-active" : ""}`}
          >
            <span
              className={`forget-step__index ${
                activeIndex > 0 ? "is-pass" : ""
              }`}
            >
              {activeIndex > 0 ? <i className="iconfont icon-true" /> : "1"}
            </span>
            <p className="forget-step__title">验证账号</p>
            <p className="forget-step__sub">完成账号验证</p>
          </div>
          <div
            className={`forget-step is-middle ${
              activeIndex === 1 ? "is-vaild" : ""
            }`}
          >
            <span
              className={`forget-step__index ${
                activeIndex > 1 ? "is-pass" : ""
              }`}
            >
              {activeIndex > 1 ? (
                <i className="iconfont icon-true" />
              ) : activeIndex === 1 ? (
                <i className="iconfont icon-iconguanbi" />
              ) : (
                "2"
              )}
            </span>
            <p className="forget-step__title">确认验证码</p>
            <p className="forget-step__sub">请输入验证码</p>
          </div>
          <div className="forget-step__line is-first" />
          <div className="forget-step__line" />
          <div className="forget-step">
            <span className="forget-step__index">3</span>
            <p className="forget-step__title">重置密码</p>
            <p className="forget-step__sub">请输入新密码</p>
          </div>
        </div>
        <div className="forget__container">
          {activeIndex === 0 && (
            <ForgetPwd
              getVerificationCode={(loginName, rucaptcha, cb) => {
                this.setloginNameAndSend(loginName, rucaptcha, cb);
              }}
            />
          )}
          {activeIndex === 1 && (
            <Fragment>
              <p className="forget__tip">
                我们已经向您的注册账户
                {this.state.loginName}
                &nbsp;发送了一个验证码，请您
                <span>注意查收</span>
              </p>
              <VerificationCode
                sendVerify={code => {
                  this.sendVerify(code);
                }}
              />
              <p className="forget__tip forget__send">
                没有收到？
                <span
                  onClick={() => {
                    this.resend();
                  }}
                >
                  重新发送
                </span>
              </p>
            </Fragment>
          )}
          {activeIndex === 2 && (
            <ResetPwd
              resetPwd={password => {
                this.resetPwd(password);
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

RetrievePwd.propTypes = {
  actions: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};

RetrievePwd.defaultProps = {
  isMobile: false,
};

export default ReduxWrapper(RetrievePwd);
